/*
 * What a region shows instead of its data: nothing there yet (EmptyState) or a failed load
 * (ErrorState, with a retry). Not in Figma; the views' own "nothing found" lines and the app's
 * unreachable message, made one: 400 14/20, --text-weak / --text-danger, the page gutter.
 */
import type { ReactNode } from 'react'
import { Button } from './Button'
import { cx } from './cx'

export function EmptyState({ children, action, className, testId }: { children: ReactNode; action?: ReactNode; className?: string; testId?: string }) {
    return (
        <div data-testid={testId} className={cx('flex flex-col items-start gap-[12px] py-[24px]', className)}>
            <p role="status" className="m-0 text-[14px] leading-[20px] font-normal text-[var(--text-weak)]">
                {children}
            </p>
            {action}
        </div>
    )
}

export function ErrorState({
    children,
    retryLabel,
    onRetry,
    className,
    testId,
}: {
    children: ReactNode
    retryLabel?: string
    onRetry?: () => void
    className?: string
    testId?: string
}) {
    return (
        <div data-testid={testId} className={cx('flex flex-col items-start gap-[12px] py-[24px]', className)}>
            <p role="alert" className="m-0 text-[14px] leading-[20px] font-normal text-[var(--text-danger)]">
                {children}
            </p>
            {onRetry && retryLabel && <Button onClick={onRetry}>{retryLabel}</Button>}
        </div>
    )
}
